import React from 'react'
import { Box, Button as MuiTextButton } from '@mui/material'
import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../interaxDesignSystemComponents'
import { TESTIDS } from '../../../../config/testids'
import { tourFooterBackSx, tourFooterNextSx, tourFooterSkipSx, tourFooterSx, tourSkipSx } from './platformTourStyles'

interface PlatformTourStopFooterProps {
  nextLabel: string
  hasBack: boolean
  onSkip: () => void
  onBack: () => void
  onNext: () => void
}

/** Skip on the left, Back and Next on the right. */
export const PlatformTourStopFooter: React.FC<PlatformTourStopFooterProps> = ({
  nextLabel,
  hasBack,
  onSkip,
  onBack,
  onNext
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={tourFooterSx}>
      <Box sx={tourFooterSkipSx}>
        <MuiTextButton onClick={onSkip} disableRipple sx={tourSkipSx} data-testid={TESTIDS.PLATFORM_TOUR_SKIP_BTN}>
          {t('gamer.platformTour.skipTour')}
        </MuiTextButton>
      </Box>

      {hasBack && (
        <Box sx={tourFooterBackSx}>
          <Button variant="secondary" onClick={onBack} data-testid={TESTIDS.PLATFORM_TOUR_BACK_BTN}>
            {t('common.back')}
          </Button>
        </Box>
      )}

      <Box sx={tourFooterNextSx}>
        <Button
          variant="primary"
          fullWidth
          icon={<ArrowRightIcon className="w-4 h-4" />}
          iconPosition="right"
          onClick={onNext}
          data-testid={TESTIDS.PLATFORM_TOUR_NEXT_BTN}
        >
          {nextLabel}
        </Button>
      </Box>
    </Box>
  )
}
